import utils from '../utils';
import Handlebars from 'handlebars';
import { SupplierListingItemBlock } from './supplierListingItemBlock';
import { ifCond } from '../../../handlebarsHelpers';

const NS = 'SupplierListingBlock';
const CLS = 'supplierListingBlock';

export class SupplierListingBlock {
	constructor(element) {
		// $el is the widget node return by the loadShopProductBlock function
		this.$el = $(element);
		this.$filterKeys = this.$el.find(`[data-filter-key]`);
		this.$filterDropdown = this.$el.find(`.${CLS}-filters-dropdown`);
		this.$filterDropdownMenu = this.$el.find(`.${CLS}-filters-dropdown-menu`);
		this.$searchResultsEmpty = this.$el.find(`.${CLS}-searchResults-empty`);
		this.$supplierLists = this.$el.find(`.${CLS}-suppliers`);
		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);
		this.$loadMoreBtn = this.$el.find(`#loadMoreBtn`);
		this.$loadMore = this.$el.find(`.${CLS}-searchResults-loadMore`);
		this.$searchInp = this.$el.find(`.${CLS}-searchInput`);
		this.$clearFilterBtn = this.$el.find(`.${CLS}-filterBtnClear`);
		this.$cateContents = this.$el.find(`.${CLS}-cate-contents`);
		this.$cateContentsTitle = this.$el.find(`.${CLS}-cate-contents-title`);
		this.$cateContentsDescription = this.$el.find(`.${CLS}-cate-contents-description`);
		this.$cateCertifiedTitle = this.$el.find(`.${CLS}-certified-contents-title`);
		this.$cateCertifiedDescription = this.$el.find(`.${CLS}-certified-contents-description`);
		this.$searchBar = this.$el.find(`.${CLS}-searchBar`);
		this.$searchBarIcon = this.$el.find(`.${CLS}-searchBar-icon`);
		this.$faBars = this.$el.find(`.fa-bars`);
		this.$faTimes = this.$el.find(`.fa-times`);
		this.$countries = this.$el.find(`#countries`);
		this.$types = this.$el.find(`#types`);
		this.$sustainabilities = this.$el.find(`#sustainabilities`);

		this.$searchBarFilters = this.$el.find(`.${CLS}-searchBar-refined-filters`);

		this.getSuppliersApi = this.$el.data('suppliersApi');
		this.loadingSuppliers = false;
		this.allSuppliersLoaded = false;
		this.pageSize = this.$el.data('pageSize');
		this.pageNumber = 1;
		//----- Retrive the parameter values from the URL for dropdown menu if URL has default value ------//
		var url_string = window.location.href; 
		var url = new URL(url_string);

		var offset = this.$searchBar.offset();

		window.onscroll = ()=> {
			if (window.scrollY > offset.top-60) {
				this.$searchBar.addClass("sticky");
				this.$supplierLists.css("margin-top", "100px");
			} else if(window.scrollY < offset.top+60) {
				this.$searchBar.removeClass("sticky");
				this.$supplierLists.css("margin-top", "0px");
			}
		}

		this.$urlkeyword = url.searchParams.get("keyword");
		if(this.$urlkeyword != null && this.$urlkeyword.length > 0){
			this.$searchInp.val(this.$urlkeyword);
		}
		this.$urlcountries = url.searchParams.get("countries");
		this.$urlsustainabilities = url.searchParams.get("sustainabilities");
		this.$urltypes = url.searchParams.get("types");

		this.isFilterPopulated = false;
		//----- End for retrive the parameter values from the URL-----//

		this.initParams();
		$('.selectpicker').selectpicker('destroy').selectpicker();
		this.getItems(false);
		this.handleSearchInput();
		this.handleFilterClearBtn();
		this.handleScrollLoading();
		this.initFilterKeys();
	}

	initParams(clear){
		// for clear btn - if user clear the filter everthing needs to be empty
		if(clear){
			this.params = {
				count: this.pageSize,
				offset: 0,
				keyword: '',
				countries: '',
				types: '',
				sustainabilities: '',
			};
		}
		// for initial parameter values when page loads
		else{
			this.params = {
				count: this.pageSize,
				offset: 0,
				keyword: this.$urlkeyword || '',
				countries: this.$urlcountries || '',
				types: this.$urltypes || '',
				sustainabilities: this.$urlsustainabilities|| '',
			};
		}
	}

	// individual product template
	getSupplierListingItemBlockTemplate() {
		let supplierListingItemBlock = require('../../partials/widgets/supplierListingItemBlock.hbs');
		Handlebars.registerPartial('supplierListingItemBlock', supplierListingItemBlock);

		let template = `
			{{> supplierListingItemBlock
				wg="supplierListingItemBlock"
				ns="SupplierListingItemBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		Handlebars.registerHelper('ifCond', ifCond);
		return Handlebars.template(precompiled);

	}

	// Get items (reload content)
	getItems(loadMoreSuppliers) {
		// Check if all the products have been loaded
		if (!this.loadingSuppliers && !this.allSuppliersLoaded) {
			this.loadingSuppliers = true;

			let url = this.getSuppliersApi;

			if (loadMoreSuppliers) {
				this.setPageNumber(this.pageNumber + 1);
				this.$loadMore.addClass('active');
			} else {
				this.$loadingScreen.addClass('active');
			}
			// if parameter is not empty, then append to the API url
			if (!_.isEmpty(this.params)) {
				url += `?${$.param(this.params)}`;
			}
			
			// End for display the products category

			this.updateUrl();
			// ajax load products data
			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {
					if(!this.isFilterPopulated){
						if(this.$urlcountries !== null){
							data.filters.countries.forEach((item) => {
								if(this.$urlcountries.includes(item)){
									this.$countries.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+item+`'">`+item+`</option>`);
								}
								else{
									this.$countries.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
								}
							});
						}
						else{
							data.filters.countries.forEach((item) => {
								this.$countries.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
							});
						}
						if(this.$urltypes !== null){
							data.filters.types.forEach((item) => {
								if(this.$urltypes.includes(item)){
									this.$types.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+item+`'">`+item+`</option>`);
								}
								else{
									this.$types.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
								}
							});
						}
						else{
							data.filters.types.forEach((item) => {
								this.$types.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
							});
						}
						if(this.$urlsustainabilities !== null){
							data.filters.sustainabilities.forEach((item) => {
								if(this.$urlsustainabilities.includes(item)){
									this.$sustainabilities.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+item+`'">`+item+`</option>`);
								}
								else{
									this.$sustainabilities.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
								}
							});
						}
						else{
							data.filters.sustainabilities.forEach((item) => {
								this.$sustainabilities.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
							});
						}
						this.isFilterPopulated = true;
						this.$countries.selectpicker('refresh');
						this.$types.selectpicker('refresh');
						this.$sustainabilities.selectpicker('refresh');
					}

					this.$searchResultsEmpty.hide();
					// Check if this is the new search, if so empty previous products in the products div
					if (!loadMoreSuppliers) {
						this.$supplierLists.empty();
					}
					//check if has any data from the API, if so, append the data into the product template.
					if (data.suppliers.length > 0) {
						data.suppliers.forEach((item) => {
							if(item.website == null){
								var url = "";
								item.website = "";
							}
							else{
								var url = item.website.substring(8);
								if(url.substr(url.length-1) === "/"){
									var url = url.slice(0, -1);
								}
							}
							var newitem = {...item, url};
							let $column = this.$supplierLists.append(this.getSupplierListingItemBlockTemplate()(newitem));
							new SupplierListingItemBlock($column.find(`[data-wg="SupplierListingItemBlock"]`).last()[0], newitem);
						});
					} else {
						if (loadMoreSuppliers) {
							this.allSuppliersLoaded = true;
						} else {
							this.$loadMoreBtn.css("display", "none");
							this.$searchResultsEmpty.show();
						}
					}

					if (data.suppliers.length < this.pageSize) {
						this.$loadMoreBtn.css("display", "none");
					}
					this.$loadingScreen.removeClass('active');
					this.$loadMore.removeClass('active');
					
				},
				error: (error) => {

				},
				complete: () => {
					this.loadingSuppliers = false;
				},
			});
		}
	}

	// Update url after filters change
	updateUrl() {
		let uri = document.location.pathname;
		Object.keys(this.params).forEach((key, index) => {
			uri = utils.updateQueryStringParameter(uri, key, encodeURIComponent(this.params[key]));
		});
		// update url without reload
		window.history.pushState('', '', uri);
		let urlParams = new URLSearchParams(uri);

	}

	// Search text input - on type
	handleSearchInput() {
		this.$searchInp.on('keyup', (event) => {
			if(event.keyCode === 13) {
				this.params['keyword'] = $(event.currentTarget).val().trim();
				this.setPageNumber(1);
				this.allSuppliersLoaded = false;
				this.getItems(false);
			}
		});
	}

	// Clear button
	handleFilterClearBtn() {
		this.$clearFilterBtn.on('click', () => {
			// set 1 to let initParams know it's coming from clear btn
			this.initParams(1);
			this.setPageNumber(1);
			this.allSuppliersLoaded = false;
			// Scroll to top
			window.scrollTo(0, 0);
			this.$countries.selectpicker('val', '');
			this.$types.selectpicker('val', '');
			this.$sustainabilities.selectpicker('val', '');
			$(".selectpicker").selectpicker('deselectAll');
			this.getItems(false);
			this.$searchInp.val('');
		});
	}

	handleFilterClick($element) {
		let filterKey = $element.data('filterKey') || '';
		let value = [];
		value.push($element.val());
		this.$el.find(`[data-filter-key="${filterKey}"]`).removeClass('active');
		$element.addClass('active');

		if(!(_.isNil(this.params[filterKey]) && value === '')) {
			// Ensure that the filterKey does not match the current select value
			if(this.params[filterKey] !== value) {
				if(_.isNil(value) || value === '') {
					delete this.params[filterKey];
				}
				else {
					this.params[filterKey] = value.toString();
				}
				this.setPageNumber(1);
				this.allSuppliersLoaded = false;
				this.getItems(false);
			}
		}
	}

	// initialise the filter keys
	initFilterKeys() {
		this.$filterKeys.on('change', (event) => {
			let $element = $(event.currentTarget);
			this.handleFilterClick($element);
		});

	}

	handleScrollLoading() {

		// when scroll to buttom before 200px, page will trigger the load more function.
		let offsetFromBottom = 200;
		const This = this;
		this.$loadMoreBtn.on('click', (event) => {
			This.getItems(true);
		});
	}

	setPageNumber(newPageNumber) {
		this.pageNumber = newPageNumber;
		this.params.offset = (this.pageNumber - 1) * this.pageSize;
	}
}
